import { setComponent } from 'src/local-component/module/tip-match/global-component/global';
function ShareTips(options) {
  const component = setComponent('UiTipMatchSharePrompt', options);
  component?.showTips(options);
  return component;
}
export default ShareTips;

